import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import {getUrlParameters} from '../../../common/util/urlParameters';
import {navigateTo} from '../../../router/actions';
import {paths} from '../../../common/dictionaries/urls';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsCourses = (params) => apiActionCreator({
  'endpoint': `/wts/courses${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_COURSES,
    ActionTypes.FETCHED_WTS_COURSES,
    [
      ActionTypes.FETCHED_WTS_COURSES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getWtsCourse = (courseId) => apiActionCreator({
  'endpoint': `/wts/courses/course/${courseId}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_COURSE,
    ActionTypes.FETCHED_WTS_COURSE,
    [
      ActionTypes.FETCHED_WTS_COURSE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const createWtsCourse = (data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/wts/courses/course',
    'authenticated': true,
    'types': [
      ActionTypes.CREATE_WTS_COURSE,
      [
        dispatch(MessageActions.addMessageBoxInfo('Curso creado correctamente')),
        (response) => {
          dispatch(navigateTo(paths.WtsCourseEdit.replace(':courseId', response?.data)));
          return {
            'type': ActionTypes.CREATED_WTS_COURSE,
          };
        },
      ],
      [
        ActionTypes.CREATED_WTS_COURSE_FAILED,
        (error) => buildErrorMessage(error),
        () => {
          throw new Error('WTS_COURSE_CREATE_FAILED');
        },
      ],
    ],
    'microservice': 'part',
    'data': data,
    'method': 'POST',
    'contentType': 'application/json',
  }));
};

export const updateWtsCourse = (courseId, data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/wts/courses/course/${courseId}`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATE_WTS_COURSE,
      [
        ActionTypes.UPDATED_WTS_COURSE,
        () => dispatch(MessageActions.addMessageBoxInfo('Curso actualizado correctamente')),
      ],
      [
        ActionTypes.UPDATED_WTS_COURSE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'data': data,
    'method': 'PUT',
    'contentType': 'application/json',
  }));
};

export const deleteWtsCourse = (courseId, data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/wts/courses/course/${courseId}`,
    'authenticated': true,
    'types': [
      ActionTypes.DELETING_WTS_COURSE,
      [
        () => {
          dispatch(getWtsCourses({'area': data.area}));
          return {
            'type': ActionTypes.DELETED_WTS_COURSE,
          };
        },
      ],
      [
        ActionTypes.DELETED_WTS_COURSE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'data': data,
    'method': 'DELETE',
    'contentType': 'application/json',
  }));
};

export const changeWtsCourseForm = (field, value) => ({
  'type': ActionTypes.CHANGE_WTS_COURSE_FORM,
  field,
  value,
});

export const cleanWtsCourseForm = () => ({
  'type': ActionTypes.CLEAN_WTS_COURSE_FORM,
});

export const getWtsCoursesFilter = (params) => apiActionCreator({
  'endpoint': `/wts/courses${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_COURSES_FILTER,
    ActionTypes.FETCHED_WTS_COURSES_FILTER,
    [
      ActionTypes.FETCHED_WTS_COURSES_FILTER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getWtsCertificacion = (codemp) => apiActionCreator({
  'endpoint': `/wts/certificacion?codemp=${codemp}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_CERTIFICACION,
    ActionTypes.FETCHED_WTS_CERTIFICACION,
    [
      ActionTypes.FETCHED_WTS_CERTIFICACION_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const createWtsCertificacion = (data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/wts/certificacion',
    'authenticated': true,
    'types': [
      ActionTypes.CREATING_WTS_CERTIFICACION,
      [
        () => {
          dispatch(getWtsCertificacion(data.codemp));
          return {'type': ActionTypes.CREATED_WTS_CERTIFICACION};
        },
        MessageActions.addMessageBoxInfo('Certificación creada exitosamente'),
      ],
      [
        ActionTypes.CREATED_WTS_CERTIFICACION_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'data': data,
    'method': 'POST',
    'contentType': 'application/json',
  }));
};

export const updateWtsCertificacion = (data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/wts/certificacion',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_WTS_CERTIFICACION,
      [
        () => {
          dispatch(getWtsCertificacion(data.codemp));
          return {'type': ActionTypes.UPDATED_WTS_CERTIFICACION};
        },
        MessageActions.addMessageBoxInfo('Certificación actualizada exitosamente'),
      ],
      [
        ActionTypes.UPDATED_WTS_CERTIFICACION_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'data': data,
    'method': 'PUT',
    'contentType': 'application/json',
  }));
};

export const deleteWtsCertificacion = (data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/wts/certificacion',
    'authenticated': true,
    'types': [
      ActionTypes.DELETING_WTS_CERTIFICACION,
      [
        () => {
          dispatch(getWtsCertificacion(data.codemp));
          return {'type': ActionTypes.DELETED_WTS_CERTIFICACION};
        },
        MessageActions.addMessageBoxInfo('Certificación eliminada exitosamente'),
      ],
      [
        ActionTypes.DELETED_WTS_CERTIFICACION_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'data': data,
    'method': 'DELETE',
    'contentType': 'application/json',
  }));
};
